import { useMemo } from 'react';
import Lottie from 'lottie-react';

import polonaiseLetterTemplate from '@/features/letterParty/assets/lottie/polonaise-letter.json';

const WORD = 'letterfeestje';

// Helper function to efficiently clone and customize animation data for a letter
const createLetterAnimation = (letter: string, template: any) => {
	// Use structuredClone if available (modern browsers), fallback to JSON method
	const animationData =
		typeof structuredClone === 'function' ? structuredClone(template) : JSON.parse(JSON.stringify(template));

	if (animationData.assets?.[0]?.layers) {
		const textLayer = animationData.assets[0].layers.find((layer: any) => layer.nm === 'LETTER');

		if (textLayer?.t?.d?.k) {
			textLayer.t.d.k.forEach((keyframe: any) => {
				if (keyframe.s?.t !== undefined) {
					keyframe.s.t = letter;
				}
			});
		}
	}

	return animationData;
};

const PolonaiseLine = () => {
	const letters = useMemo(() => WORD.split(''), []);

	const letterAnimations = useMemo(() => {
		return letters.map((letter) => createLetterAnimation(letter, polonaiseLetterTemplate));
	}, [letters]);

	return (
		<div className="letter-party-game__polonaise-line">
			{letterAnimations.map((animationData, index) => (
				<div
					key={`${letters[index]}-${index}`}
					className="letter-party-game__polonaise-letter"
					style={{
						animationDelay: `${index * 0.05}s`,
					}}
				>
					<Lottie animationData={animationData} loop autoplay />
				</div>
			))}
		</div>
	);
};

export default PolonaiseLine;
